import { gql } from "graphql-request";

export const ADMIN_USER_CONVERSATIONS = gql`
  query AdminUserConversations($input: AdminUserConversationsInputDto!) {
    adminUserConversations(input: $input) {
      user {
        id
        email
        name
      }
      items {
        sessionId
        title
        sessionType
        workspaceId
        workspaceName
        messageCount
        totalTokensUsed
        lastMessageAt
        createdAt
      }
      meta {
        totalCount
        totalPages
        currentPage
        limit
        hasNextPage
        hasPrevPage
      }
    }
  }
`;

export const ADMIN_USER_CONVERSATION_MESSAGES = gql`
  query AdminUserConversationMessages(
    $input: AdminUserConversationMessagesInputDto!
  ) {
    adminUserConversationMessages(input: $input) {
      sessionId
      title
      sessionType
      messages {
        messageId
        role
        content
        model
        tokenCount
        createdAt
        feedbackRating
      }
      nextCursor
      hasMore
    }
  }
`;
